import { GlobalState } from 'store/types';

export const newCampaignProposalsSelector = (state: GlobalState) => state.pages.posHome.newCampaignProposals;
